import React from 'react';
import * as R from 'ramda';
import { Form, Modal, Layout, Dropdown, Icon, Avatar, Menu, Button } from 'antd';
import { DropTarget, DragDropContext, ConnectDropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import DraggableAppTab from './DraggableAppTab';

export const swap = R.curry((index1, index2, list) => {
  if (index1 < 0 || index2 < 0 || index1 > list.length - 1 || index2 > list.length - 1) {
    return list; // index out of bound
  }
  const value1 = list[index1];
  const value2 = list[index2];
  return R.pipe(
    R.set(R.lensIndex(index1), value2),
    R.set(R.lensIndex(index2), value1),
  )(list);
});

const appTabTarget = {
  drop() {
    //
  },
};

@DragDropContext(HTML5Backend)
@DropTarget('appTab', appTabTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
class AppTabGroup extends React.Component {
  state = {
    tabOrderIds: [],
  };

  constructor(props) {
    super(props);
    this.tabGroupRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    return {
      tabOrderIds: [].concat(
        R.without(
          R.difference(
            state.tabOrderIds,
            R.pluck('id')(props.tabs),
          ),
          state.tabOrderIds,
        ),
        R.difference(
          R.pluck('id')(props.tabs),
          state.tabOrderIds,
        ),
      ),
    };
  }

  moveAppTab = (id, atIndex) => {
    const { tabOrderIds } = this.state;
    this.setState({
      tabOrderIds: tabOrderIds.indexOf(id) >= 0 ? swap(tabOrderIds.indexOf(id), atIndex, tabOrderIds) : tabOrderIds,
    });
  };

  findAppTab = (id) => {
    const { tabOrderIds } = this.state;

    return tabOrderIds.indexOf(id);
  };

  handleScrollLeft = () => {
    const element = this.tabGroupRef.current.getElementsByClassName('vb-tab_window-bar-group-contents')[0];
    const children = [...element.childNodes]
      .filter(child => child.offsetLeft <= element.scrollLeft)
    ;

    if (children.length) {
      element.scrollLeft = (
        children[children.length - 1].offsetLeft + children[children.length - 1].offsetWidth
      ) - element.offsetWidth;
    } else {
      element.scrollLeft = 0;
    }
  };

  handleScrollRight = () => {
    const element = this.tabGroupRef.current.getElementsByClassName('vb-tab_window-bar-group-contents')[0];
    const children = [...element.childNodes]
      .filter(child => (child.offsetLeft + child.offsetWidth) >= (element.scrollLeft + element.offsetWidth));

    if (children.length) {
      element.scrollLeft = children[0].offsetLeft;
    } else {
      element.scrollLeft = element.scrollWidth;
    }
  };

  componentDidUpdate(prevProps) {
    const { tabs } = this.props;
    if (prevProps.tabs.length < tabs.length) {
      const element = this.tabGroupRef.current.getElementsByClassName('vb-tab_window-bar-group-contents')[0];
      window.requestAnimationFrame(() => { element.scrollLeft = element.scrollWidth; });
    }
  }

  render() {
    const { activeTabId, connectDropTarget, tabs, onOpen, onClose } = this.props;
    const { tabOrderIds } = this.state;
    return (
      <div className="vb-tab_window-bar-group vb-tab_window-bar-group--scrollable" ref={this.tabGroupRef}>
        <button
          type="button"
          onClick={this.handleScrollLeft}
          className="vb-tab_window-bar-group-arrow vb-tab_window-bar-group-arrow--left"
        >
          <Icon type="left" />
        </button>
        {connectDropTarget(
          <div className="vb-tab_window-bar-group-contents">
            {R
              .props(tabOrderIds, R.indexBy(R.prop('id'), tabs))
              .map(tab => (
                <DraggableAppTab
                  key={tab.id}
                  isActive={tab.id === activeTabId}
                  onOpen={onOpen}
                  onClose={onClose}
                  findAppTab={this.findAppTab}
                  moveAppTab={this.moveAppTab}
                  {...tab}
                />
              ))
            }
          </div>,
        )}
        <button
          type="button"
          onClick={this.handleScrollRight}
          className="vb-tab_window-bar-group-arrow vb-tab_window-bar-group-arrow--right"
        >
          <Icon type="right" />
        </button>
      </div>
    );
  }
}

export default AppTabGroup;
